import styled from 'styled-components';

import LockClockIcon from 'components/icons/lock-clock';
import LockClockBadgeIcon from 'components/icons/lock-clock-badge';
import { primitive } from 'styles/constants/primitives';

export const UpcomingOfferIconContainer = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  z-index: ${Styles.zIndex.top};
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledLockClock = styled(LockClockIcon)`
  width: 2.5rem;
  height: 2.5rem;
  top: 50%;
  left: 50%;
  border-radius: 2px;
`;

export const StyledLockClockBadge = styled(LockClockBadgeIcon)`
  width: 1rem;
  height: 1rem;
  margin-right: 0.25rem;
`;

export const Badge = styled.div`
  display: flex;
  background-color: ${primitive.$blackOpacity4};
  width: fit-content;
  height: 1.5rem;
  padding: 0 0.5rem;
  align-items: center;
  font-size: 0.75rem;
  font-family: ${Styles.fontFamily.body};
`;
